import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CsvStore } from "../../model/csv-management.model";

export const selectCsvManagementStore = createFeatureSelector<CsvStore>('csvManagementStore');

export const selectCsvManagementServerValidationStatus = createSelector(selectCsvManagementStore, (csvStore) => csvStore.serverValidationStatus);

export const selectCsvManagementServerValidationMessage = createSelector(selectCsvManagementStore, (csvStore) => csvStore.serverValidationMessage);

export const selectCsvManagementIsProcessing = createSelector(selectCsvManagementStore, (csvStore) => csvStore.isProcessing);